import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Arrow icon. Exported from Figma (Bombiix 2026). */
const ArrowIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M10.3125 5.64637C10.5077 5.45116 10.8243 5.45127 11.0195 5.64637L14.5488 9.17469C15.0044 9.63028 15.0044 10.3695 14.5488 10.8251L11.0195 14.3534C10.8243 14.5485 10.5077 14.5486 10.3125 14.3534C10.1175 14.1582 10.1175 13.8416 10.3125 13.6464L13.46 10.4999H5.33301C5.05687 10.4999 4.83301 10.276 4.83301 9.99988C4.83301 9.72374 5.05687 9.49988 5.33301 9.49988H13.46L10.3125 6.3534C10.1175 6.15818 10.1175 5.84159 10.3125 5.64637Z"
      fill="currentColor"
    />
  </svg>
);

export default ArrowIcon;
